import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Col } from "react-awesome-styled-grid";
import { FlexContainer, H1Text, Hr, Text } from "../../design";
import React, { useState, useEffect, useRef } from "react";
import ApplePayLogo from "../icons/ApplePay";
import { TABLET_SCREEN_WIDTH } from "../../appconstants";


type Props = {
  tabs: Array,
  tabPanels: Array,
  onSelect: Function,
  defaultSelectedTab: number,
  name: string,
  mode: String,
  paymentTypes: string,
  tabName: string,
  upiDown: Boolean,
  interval: String,
  accountGid: String,
};

const PaymentMethodTabs = (props: Props) => {
  const { tabs, tabPanels, onSelect, defaultSelectedTab, name, paymentTypes, tabName, mode, upiDown, applePayment,isApplePay,interval, accountGid } = props;
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedTab || 0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const listRef = useRef(null);
  const [leftScrollIndicator, setLeftScrollIndicator] = useState(false);
  const [rightScrollIndicator, setRightScrollIndicator] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const localOnSelect = data => {
    setTabIndex(data);
    setSelectedIndex(data);
    localStorage.setItem(`${name}-tap-index`, data);
    if (onSelect) { onSelect(data); }
  };

  useEffect(() => {
    const checkScroll = () => {
      if(!listRef.current) return;
      const {
        scrollLeft,
        scrollWidth,
        clientWidth,
      } = listRef.current;
      setLeftScrollIndicator( scrollLeft > 30);
      setRightScrollIndicator( scrollLeft <= scrollWidth - clientWidth - 30 || scrollWidth - clientWidth -30 < 0);
    };
    if (listRef?.current) {
      checkScroll();
      listRef.current.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
    }
    const permanentListRef = listRef?.current ?? null;
    return () => {
      if(permanentListRef) {
        permanentListRef.removeEventListener('scroll', checkScroll);
      }
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  const customScrollIndicatorStyle = (position) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '30vw',
    height: 'auto',
    zIndex: '1',
    pointerEvents: 'none',
    background: (
      position === 'left' ? 
      'linear-gradient(to right, rgba(255, 255, 255, 0.9), transparent)' :
      'linear-gradient(to left, rgba(255, 255, 255, 0.9), transparent)'
    ),
    left: position === 'left' ? 0 : 'auto',
    right: position === 'right' ? 0 : 'auto',
  });


  return (
    <FlexContainer
      className="pt-3 pt-lg-5 w-100"
      box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
      display="flow-root"
      backgroundColor="#fff"
      borderRadius="10px"
      marginTop="5%"
      marginBottom="5%"
    >
      <H1Text
        className="px-4 px-md-4"
        marginBottom="30px"
        fontWeight="bold"
        fontSize="20px"
      >
        {mode === 'Transfer' ? 'Provide Bank Account' : 'Select Payment Method'}
        
      </H1Text>
      <Tabs 
        className="tab" 
        onSelect={localOnSelect} 
        selectedIndex={selectedIndex} 
        selectedTabClassName="text-primary tab-active"
      >
        <div
          style={{
            position: 'relative',
            overflowX: 'hidden',
            width: '100%',
          }}
        >
        { leftScrollIndicator && <div style={customScrollIndicatorStyle("left")}></div> }
        <div 
          ref={listRef} 
          style={{
              overflowX: 'auto',
            }}
          >
        <TabList 
          ref={listRef}
          className="px-1 px-md-4 row" 
          style={screenWidth > TABLET_SCREEN_WIDTH ? {
            // overflowX:"auto",
            flexWrap:"nowrap",
            width:"100%",
            listStyle:"none",
          } : {
            marginLeft:"5%",
            marginRight:"5%",
            // overflowX:"auto",
            flexWrap:"nowrap",
            width:"80vw",
            height:"auto",
            listStyle:"none",
          }}
        >
          {tabs && tabs.map((value, index) => (
            <Tab 
              key={index} 
              disabled={(upiDown && value.name === "UPI") ? upiDown : value.disabled}
              className={value.name === "UPI / QR"
                ? "col-3 col-sm-2 col-md-2 mr-1 text-center remove-dot-before-list"
                : value.name === "INSTANT PAYMENT"
                  ? "col-3 col-sm-2 col-md-2 mr-1 text-center remove-dot-before-list"
                  : "col-3 col-sm-2 col-md-2 mr-1 text-center remove-dot-before-list"}
              style={{ 
                outline: "none", 
                width: "32vw !important",
                cursor: (upiDown && value.name === "UPI") ? "no-drop" :  (value.disabled ? "no-drop" : "pointer") 
              }}>
              {value.disabled && selectedIndex === index && setSelectedIndex(0)}
              <Col className="tab-menu-content">
                <div 
                  style={{ 
                    display: "flex",
                    alignContent: "space-around",
                    justifyContent: "space-around",
                    alignItems: "center",
                    height: "40px", 
                    cursor: (upiDown && value.name === "UPI") ? "no-drop !important" : (value.disabled ? "no-drop !important" : "pointer !important") 
                  }}
                >
                  {value.icon}
                </div>
                <Text 
                  className="tab-menu-content-text text-center" 
                  color="inherit" 
                  fontWeight="600" 
                  style={{ 
                    outline: "none",
                    cursor: (upiDown && value.name === "UPI") ? "no-drop" : (value.disabled ? "no-drop" : "pointer") 
                  }} 
                  paddingBottom="3px"
                >
                  {value.name.split('_').map((nameParts) => nameParts + " ")}
                </Text>
              </Col>
            </Tab>
          ))}
   { (interval === "ONETIME" || !interval) && applePayment && isApplePay ? (
    <Tab style={{ marginLeft: '10px' }} className="remove-dot-before-list">
      <Col className="tab-menu-content">
        <div style={{   
          display: "flex",
          alignContent: "space-around",
          justifyContent: "space-around",
          alignItems: "center",
          height: "40px",
          cursor: "pointer" 
          }}
        >
          <ApplePayLogo />
        </div>
        <Text 
          className="tab-menu-content-text text-center" 
          color="inherit" 
          fontWeight="600" 
          style={{ outline: "none", cursor: "pointer" }} 
          paddingBottom="3px"
        >
          APPLE PAY{/* Zero-width space */}
        </Text>
      </Col>
    </Tab>
) :  
null
}
{/* <Hr width="100%" marginTop="15px" borderTop="1px solid rgba(0, 0, 0, 0.1)" /> */}
            
        </TabList>
        </div>
        { rightScrollIndicator && <div style={customScrollIndicatorStyle("right")}></div> }
        </div>
        <FlexContainer
          justifyContent={screenWidth < TABLET_SCREEN_WIDTH ? "center" : "flex-start"}
          alignItems="center"
          alignContent="center"
          // paddingLeft={screenWidth < TABLET_SCREEN_WIDTH ? 0 : "5%"}
        >
        {(mode === 'Transfer') && (paymentTypes === 'US') ? (
          <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in United States or Canada to receive funds.</Text>
        ) : (mode === 'Transfer') && (paymentTypes === 'IN') ? (
          <Text className="px-1 px-md-4  px-xs-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in India to receive funds.</Text>
        ) : ((tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'ACH') ? (
          <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">Please provide a valid bank account in United States or Canada.</Text>
        ) : ((tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'NET_BANKING') ? (
          <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">Choose from a complete range of national and international banks.</Text>
        ) : ((tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'INSTANT_PAYMENT') ? (
          <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">Use your Swirepay Wallet</Text>
        ) : ((tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'SWIREPAY_US') ? (
          <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">Use your Swirepay Wallet</Text>
        ) : (
          <>
            {
              (tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'UPI' ? (
                <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px" style={{ lineHeight: '20px' }}>Choose from Google Pay, Paytm, Amazon Pay and other digital wallets.</Text>
              ) : (
                 <>
                 {
                  (tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'ACH' ? (
                    <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">
                       Please provide a valid bank account in United States or Canada.
                    </Text>
                  ) : (
                    <>
                    {
                      (tabs[tabIndex]?.name ? tabs[tabIndex]?.name : tabName) === 'CARD' ? (
                        <Text className="px-1 px-md-4 px-xs-4" paddingTop="8px" paddingBottom="8px">
                  {paymentTypes === 'IN'
                    ? 'Choose from Visa, Mastercard, RuPay, and more'
                    : 'Choose from Visa, Mastercard, Amex, and more'
                  }
                </Text>
                      ) : (
                        <></>
                      )
                    }
                    </>
                  )
                 }
                 </>
              )
            }

          </>
        )}
        </FlexContainer>
        {tabPanels && tabPanels.map((value, index) => (
          <TabPanel key={index}>
            <div>
              {value.children}
            </div>
          </TabPanel>
        ))}
      </Tabs>
    </FlexContainer>
  )
};

export default PaymentMethodTabs;
